const validate = (name, email, message, button) => {
	const sendBtn = document.querySelector(button);
	const inputName = document.querySelector(name);
	const inputEmail = document.querySelector(email);
	const textArea = document.querySelector(message);

	const NAME_REGEXP = /[a-zA-Zа-яА-я]/g;
	const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
	function isInputNameValid(value) {
		return (NAME_REGEXP.test(value) && value.length > 4);
	}
	function isInputEmailValid(value) {
		return (EMAIL_REGEXP.test(value) && value.length > 7);
	}
	function isTexAreaValid(value) {
		return (value.length > 1);
	}

	function validateInputs(nameOfInput, validTest) {
		function disableBtn() {
			if (isInputEmailValid(inputEmail.value) && isInputNameValid(inputName.value) && isTexAreaValid(textArea.value)) {
				sendBtn.setAttribute('disabled', '');
				sendBtn.removeAttribute('disabled');
			} else {
				sendBtn.setAttribute('disabled', '');
			}
		}
		function onInput() {
			if (validTest(nameOfInput.value)) {
				nameOfInput.classList.remove('error');
				// nameOfInput.classList.add('form__input--check');
			} else {
				// nameOfInput.classList.remove('form__input--check');
				nameOfInput.classList.add('error')
			}

		}
		nameOfInput.addEventListener('change', disableBtn);
		nameOfInput.addEventListener('change', onInput);

	}

	validateInputs(inputName, isInputNameValid);
	validateInputs(inputEmail, isInputEmailValid);
	validateInputs(textArea, isTexAreaValid);

}
module.exports = validate;